import {
  arrayRemove,
  arrayUnion,
  doc,
  type Firestore,
  updateDoc,
} from 'firebase/firestore';
import { useDocument } from 'vuefire';
import { computed, type Ref } from 'vue';

export interface FavoritesClientInterface {
  favoritesRef(): Ref<string[]>;

  setFavorite(recipeId: string, favorite: boolean): Promise<void>;
}

// Favourite recipe ids, per user, on their profile document (only the owner
// may write it)
export default class FavoritesClient implements FavoritesClientInterface {
  constructor(
    private readonly firestore: Firestore,
    private readonly uid: string,
  ) {}

  private get profile() {
    return doc(this.firestore, 'users', this.uid);
  }

  favoritesRef(): Ref<string[]> {
    const profile = useDocument(this.profile);
    return computed(() => profile.value?.favorites ?? []);
  }

  async setFavorite(recipeId: string, favorite: boolean): Promise<void> {
    await updateDoc(this.profile, {
      favorites: favorite ? arrayUnion(recipeId) : arrayRemove(recipeId),
    });
  }
}
